import { Injectable } from '@angular/core';
import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpSentEvent,
  HttpHeaderResponse,
  HttpProgressEvent,
  HttpResponse,
  HttpUserEvent,
  HttpErrorResponse,
  HttpEvent,
} from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../services/auth.service';
import { CommonService } from '../services/common.service';
import { LoaderService } from '../services/loader.service';
import { NavigationService } from '../services/navigation.service';
import { RestService } from '../services/rest.service';
import { TokenStorage } from '../services/token.service';
import { ErrorComponent } from 'src/app/pages/error/error.component';



@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  refreshTokenAttempts: number = 0;
  refreshTokenInProgress: boolean = false;
  redirectURL: any;

  constructor(
    private token: TokenStorage,
    public authService: AuthService,
    private dialog: MatDialog,
    private restService: RestService,
    private router: Router,
    private commonService: CommonService,
    private loader: LoaderService,
    private navigationService: NavigationService,
    private translate:TranslateService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<
    | HttpSentEvent
    | HttpHeaderResponse
    | HttpProgressEvent
    | HttpResponse<any>
    | HttpUserEvent<any>
  > {
    return next.handle(this.addTokenToRequest(req)).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.token.destroy();
          this.authService.isToken(false);
          this.navigationService.setPreviousUrl(this.router.url);
          this.redirectURL = '/auth/access';
          this.router.navigate([this.redirectURL]);
          return throwError(error);
        } else if (error.status !== 401) {
          return this.handleNonError(error, req);
        } else {
          return throwError(error);
        }
      })
    );
  }

  private handleNonError(
    error: HttpErrorResponse,
    req: HttpRequest<any>
  ): Observable<HttpEvent<any>> {
    switch (error.status) {
      case 404:
        this.loader.hide();
        this.dialog.closeAll();
        if (!req.url.endsWith('/login')) {
          this.router.navigate(['/error/error-status-404']);
        }
        return throwError(error);
      case 403:
        this.loader.hide();
        this.dialog.closeAll();
        this.router.navigate(['/error/error-status-403']);
        console.error('Forbidden Error:', error);
        return throwError(error);
      case 500:
        this.loader.hide();
        this.dialog.closeAll();
        if (error.error.transactionRef) {
          this.router.navigate([
            '/error/error-status-500',
            error.error.transactionRef,
          ]);
        } else {
          this.router.navigate(['/error/error-status-500']);
        }
        console.error('Internal Server Error:', error);
        return throwError(error);
      case 0:
        const errorCode = 'ERROR';
        const errorMessage = this.translate.instant(errorCode);

        console.error('Error Receiving data:', error);

        const _dialogRef = this.dialog.open(ErrorComponent, {
          width: '50VW',
          disableClose: true,
          data: {
            panelClass: ['dialog-responsive'],
            disableClose: true,
            error: true,
            trnID: error.error.transactionRef,
            errorMessage,
          },
        });

        _dialogRef.afterClosed().subscribe();
        console.error('Unexpected error:', error);
        return throwError(error);
      default:
        return throwError(error);
    }
  }

  private addTokenToRequest(
    req: HttpRequest<any>,
    token?: string
  ): HttpRequest<any> {
    if (token) {
      return req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
    }
    return req;
  }
  getAppDetails() {
    let currentUrl = window.location.href;
    this.loader.show();
    let params = {
      requestedPageURL: currentUrl,
    };
    this.restService.postUADLogin(params, 'api/UAD/GetAppDetails').subscribe(
      (data) => {
        if (data.rcode == 200) {
          this.loader.hide();
          let redirect_url = data.rObj.redirectURL;
          if (redirect_url) {
            window.location.href = redirect_url;
          }
        } else {
          this.commonService.handleRcodeError(data);
        }
      },
      (error) => {
        this.commonService.handleStatusError(error);
      }
    );
  }
}
